import type { SaleDetail } from '@entities/sale'
import { KeyValueGrid } from '@shared/design-system/ui'
import { formatMoney } from '@shared/lib/format/currency'
import { Money, type MonetaryValue } from '@shared/lib/money/money'
import { section, sectionNote, sectionTitle } from './sales.css'

export function SaleChargebackFees({ sale }: { sale: SaleDetail }) {
  const journeyCharges = [sale, ...(sale.funnelStages ?? [])]
  const charges = journeyCharges
    .map((charge) => ({
      charge,
      fees: (charge.financialEvents ?? []).filter(
        (event) => event.feeAmount && !Money.fromMonetaryValue(event.feeAmount).isZero(),
      ),
    }))
    .filter(({ fees }) => fees.length > 0)

  if (charges.length === 0) return null

  const display = (value: MonetaryValue | undefined) =>
    value ? formatMoney(value.amount, value.currency) : 'Não informado'

  return (
    <section
      className={section}
      aria-label="Multas de chargeback"
      data-testid="sale-chargeback-fees"
    >
      <span className={sectionTitle}>Multas de chargeback</span>
      <span className={sectionNote}>
        Sua parcela nas multas desta compra. Somente os valores já descontados entram no resultado
        após ajustes. A multa gerada no extrato não significa que já foi descontada.
      </span>
      {charges.map(({ charge, fees }) => (
        <div key={'saleId' in charge ? charge.saleId : charge.id}>
          {journeyCharges.length > 1 ? (
            <span className={sectionTitle}>{charge.productName}</span>
          ) : null}
          {fees.map((event, index) => (
            <KeyValueGrid
              key={`${event.kind}-${event.occurredAt}-${index}`}
              items={[
                { label: 'Multa gerada', value: display(event.feeAmount) },
                { label: 'Já descontado', value: display(event.feeRecoveredAmount) },
                { label: 'Pendente de desconto', value: display(event.feeOutstandingAmount) },
                ...(event.feeCanceledAmount
                  ? [{ label: 'Multa cancelada', value: display(event.feeCanceledAmount) }]
                  : []),
                ...(event.feeReturnedAmount
                  ? [{ label: 'Desconto devolvido', value: display(event.feeReturnedAmount) }]
                  : []),
              ]}
            />
          ))}
        </div>
      ))}
    </section>
  )
}
